import React from "react";
import styled from "styled-components";

const Banner = styled.section`
  padding: 7rem 1.5rem 3rem;
  background:
    radial-gradient(circle at 15% 30%, rgba(255, 206, 45, 0.55) 0%, transparent 50%),
    linear-gradient(180deg, #fff8e1 0%, #ffce2d 100%);
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: clamp(2rem, 5vw, 3rem);
  color: #0a2a4a;
  font-weight: 800;
  margin-bottom: 0.5rem;
`;

const PageMeta = styled.p`
  color: #0a2a4a;
  opacity: 0.8;
  font-size: 0.95rem;

  a {
    color: #0a2a4a;
    font-weight: 700;
  }
`;

const Section = styled.section`
  padding: 4rem 1.5rem 6rem;
  background: #ffffff;
`;

const Wrap = styled.article`
  max-width: 820px;
  margin: 0 auto;
  color: #2d3e56;
  line-height: 1.7;

  h2 {
    color: #0a2a4a;
    font-size: 1.25rem;
    font-weight: 800;
    margin: 2.25rem 0 0.75rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin: 0.5rem 0 1rem 1.25rem;
  }

  a {
    color: #faa71e;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const TermsAndConditions = () => {
  return (
    <>
      <Banner>
        <PageTitle>Termeni și condiții</PageTitle>
        <PageMeta>
          Ultima actualizare: 26 aprilie 2026 ·{" "}
          <a href="https://timisoara.cursaderatuste.ro">
            timisoara.cursaderatuste.ro
          </a>
        </PageMeta>
      </Banner>

      <Section>
        <Wrap>
          <h2>1. Entitate legală</h2>
          <p>
            Site-ul <strong>timisoara.cursaderatuste.ro</strong> este un proiect
            caritabil al Asociației Clubul Rotaract Timișoara, Districtul 2241
            România și Republica Moldova. Donațiile online sunt efectuate în
            contul Asociației <strong>Club Rotaract Timișoara</strong>, CUI
            14372896, înregistrată la Judecătoria Timișoara, cu sediul în
            Timișoara, Str. Eugeniu de Savoya, nr. 6, SAD 1, jud. Timiș,
            România.
          </p>

          <h2>2. Plăți online</h2>
          <p>
            Plățile online sunt procesate de către{" "}
            <strong>Stripe Payments Europe, Ltd.</strong> într-un mediu
            securizat, conform standardelor PCI DSS și legislației europene.
            Completând formularul de adopție/donație, vei fi redirecționat către
            procesatorul de plăți pentru a finaliza tranzacția.
          </p>
          <p>
            Cardurile acceptate sunt cele emise sub sigla VISA, Mastercard,
            American Express și Apple Pay / Google Pay. Asociația Club Rotaract
            Timișoara nu percepe niciun comision suplimentar pentru tranzacții.
            În cazul în care cardul este asociat unui cont în altă monedă decât
            RON, tranzacțiile se efectuează în lei, la cursul de schimb al
            băncii emitente. Procesarea datelor de card se face exclusiv prin
            intermediul platformei Stripe — nu solicităm și nu stocăm niciun
            detaliu legat de cardul tău. Tranzacțiile sunt protejate prin
            3D-Secure.
          </p>

          <h2>3. Adopția unei rățuște</h2>
          <p>
            Prin „adopția” unei rățuște, donatorul susține cauza ediției 2026 a
            Cursei de Rățuște pe Bega — dotarea Secției de Neonatologie a
            Spitalului Clinic de Urgență pentru Copii „Louis Țurcanu” din
            Timișoara. Fiecare bilet de participare costă 10 RON și înscrie o
            rățușcă în concursul ce va avea loc pe 1 iunie 2026, între Podul
            Mihai Viteazu și Podul Maria.
          </p>

          <h2>4. Livrare</h2>
          <p>
            Donația ta nu constă în produse fizice livrabile. Confirmarea
            adopției / donației se efectuează automat prin email la adresa
            specificată de tine. Biletul digital reprezintă dovada participării
            în concurs și conține numărul rățuștei tale.
          </p>

          <h2>5. Returnare și anulare</h2>
          <p>
            După confirmarea plății este imposibilă anularea sau returnarea
            donației efectuate. În cazul în care evenimentul este reprogramat,
            biletul rămâne valabil pentru noua dată comunicată oficial pe
            site-ul și paginile sociale ale evenimentului.
          </p>

          <h2>6. Premii</h2>
          <p>
            Persoanele care au biletele cu numerele rățuștelor care ajung
            primele la linia de sosire câștigă premiile oferite de partenerii
            evenimentului. Premiile se anunță în prealabil pe paginile noastre
            de Facebook și Instagram. Participantul nu este obligat să fie
            prezent la cursă pentru a-și revendica premiul.
          </p>

          <h2>7. Limitarea răspunderii</h2>
          <p>
            Organizatorul nu își asumă răspunderea pentru întârzieri sau
            modificări ale programului cauzate de condiții meteo nefavorabile,
            decizii ale autorităților locale sau alte cauze ce nu pot fi
            prevăzute. Orice modificare va fi comunicată în timp util pe site
            și pe canalele oficiale.
          </p>

          <h2>8. Contact</h2>
          <p>
            Pentru orice problemă legată de adopții, donații sau dacă dorești
            să ne oferi ajutor, ne poți scrie la{" "}
            <a href="mailto:armand.lesll@rotaract.ro">
              armand.lesll@rotaract.ro
            </a>{" "}
            sau la{" "}
            <a href="mailto:clubrotaract.timisoara@gmail.com">
              clubrotaract.timisoara@gmail.com
            </a>
            .
          </p>
        </Wrap>
      </Section>
    </>
  );
};

export default TermsAndConditions;
